<template>
    <PageHeader>
        <h1 v-if="manufacturer">
            <a
                v-if="manufacturer.WebsiteUrl"
                :href="manufacturer.WebsiteUrl"
                :data-mfr="manufacturerNameId"
                data-ga="m"
                target="_blank">
                {{ manufacturer.DisplayName }}
            </a>
            <span v-else>
                {{ manufacturer.DisplayName }}
            </span>
        </h1>
    </PageHeader>
</template>
<script setup lang="ts">
const { manufacturer } = injectManufacturer();
const manufacturerNameId = computed(() => `${manufacturer.value?.Name} [${manufacturer.value?.ManufacturerId}]`);
</script>
